<template>
  <div>
    <!-- <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :showNeed="showNeed"
                :exportNeed="exportNeed"
                @addForm="addForm"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol lg="4">
            <CInput
              label="Name"
              invalid-feedback="The Name should be filled"
              
              v-model="$v.videoEducationCategory.name.$model"
              :is-valid="!$v.videoEducationCategory.name.$invalid"
            />
          </CCol>
        </CRow>
        
        
        <CRow>
          <CCol lg="9">
            <label for="description">Description</label>
            <quill-editor
              style="height: 200px; margin-bottom: 70px"
              :content="content"
              :options="editorOption"
              :disabled="isReadonly"
              v-model="$v.videoEducationCategory.description.$model"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.videoEducationCategory.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "videoEducationCategory",
  components: { quillEditor, Loading, TableButton, JqxGrid },
  data() {
    return {
      title: "Video Education",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "name", type: "string" },
          { name: "description", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Name",
        },
        {
          datafield: "description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Description",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            // let path = this.$route.path.split("/");

            // this.$router.push({
            //   path: path.hasOwnProperty("2")
            //     ? path[2] + "/detail/" + dataRecord.id
            //     : "detail/" + dataRecord.id,
            // });
            this.editForm(dataRecord);
          },
        },
      ],
      items: null,
      videoEducationCategory: tableInterfaces.video_education_category,
      isReadonly: false,
      isLoading: false,
      addButton: false,
      isEdit: false,
      content: "",
      editorOption: {}, // data quill

      visibilityShow: false,
      showNeed: false,
      exportNeed: false,
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    videoEducationCategory: {
      name: { required },
      description: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getCategory();
    },
    getCategory: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/video_education/listing-category")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isReadonly = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.isReadonly = null;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.videoEducationCategory = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.video_education_category) {
        tableInterfaces.video_education_category[i] = null;
      }
      this.videoEducationCategory = tableInterfaces.video_education_category;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/master/video_education/add-category", this.videoEducationCategory)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/video_education/update-category", this.videoEducationCategory)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.videoEducationCategory.description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
